import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import { Button } from '@saucelabs/ds-button';
import accepts from 'attr-accept';

const UploadFileButton = ({
  label,
  acceptTypes,
  isDropzoneOpen,
  onUploadClick,
  onSelectFile,
  onUploadStartsForFile,
}) => {
  const inputFile = useRef(null);

  const handleFileUpload = (event) => {
    const { target: { files, accept } } = event;

    if (accepts(files[0], accept)) {
      onSelectFile(files[0]);
      if (!isDropzoneOpen) {
        onUploadClick(false);
      }
      onUploadStartsForFile(files[0]);
    }

    inputFile.current.value = '';
  };

  return (
    <>
      <input
        ref={inputFile}
        accept={acceptTypes.join(',')}
        onChange={handleFileUpload}
        style={{ display: 'none' }} // can't use tailwind since "hidden" would be overriden by global class
        type="file"
      />
      <Button
        className="capitalize"
        onPress={() => inputFile.current.click()}
        size="lg"
        variant="outline"
      >
        {label}
      </Button>
    </>
  );
};

UploadFileButton.propTypes = {
  acceptTypes: PropTypes.array,
  isDropzoneOpen: PropTypes.bool,
  label: PropTypes.string,
  onSelectFile: PropTypes.func.isRequired,
  onUploadClick: PropTypes.func,
  onUploadStartsForFile: PropTypes.func,
};
UploadFileButton.defaultProps = {
  acceptTypes: [],
  isDropzoneOpen: false,
  label: 'choose file',
  onUploadClick: () => {},
  onUploadStartsForFile: () => {},
};

export default UploadFileButton;
